import { Component } from '@angular/core';
import { LoaderService } from '../../service/loader.service';

@Component({
  standalone: true,
  selector: 'app-informativa-privacy',
  templateUrl: './informativa-privacy.component.html',
  imports: []
})
export class InformativaPrivacyComponent {

  constructor(private loader: LoaderService) { }

  ngOnInit(): void {
    this.loader.hide();
  }

}
